import { IntlPhoneInputModule } from '../../shared/components/intl-phone-input/intl-phone-input.module';
import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { RaceAuthComponent } from './auth/race-auth.component';

@NgModule({
  declarations: [RaceAuthComponent],
  imports: [
    CommonModule,
    ButtonModule,
    InputTextModule,
    FormsModule,
    IntlPhoneInputModule,
    MessageModule,
    MessagesModule,
    HttpClientModule,
    FieldsetModule,
    ProgressBarModule,
    ToastModule
  ],
  providers: [DatePipe, MessageService],
  exports: [RaceAuthComponent],
})
export class RaceAuthModule {}
